export default "<p>alert works!</p>\n";